import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from '../styles.js'
import { iframeOnInput } from './iframeOnInput.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const rte = closest(`${elements.rte}`, button)

    if (rte) {
      const { contentDocument } = one('iframe', rte)

      iframeOnInput(contentDocument)
    }
  }
})

export default button => {
  onClick.listen(button)
}